import { render } from "./XIconSolidAcademy.vue?vue&type=template&id=5a572a8f"
import script from "./XIconSolidAcademy.vue?vue&type=script&lang=js"
export * from "./XIconSolidAcademy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidAcademy.vue"]])

export default __exports__